import { PropsWithChildren } from "react";
import { UserComponent } from "@craftjs/core";

import { StyleSettings } from "@editor";
import {
  IBuilderBlockProps,
  BuilderBlock,
  defaultStyleProps,
} from "@uiComponents";
import { BoxSettings } from "./BoxSettings";

export interface IBoxProps extends IBuilderBlockProps {}

export const Box: UserComponent<Partial<PropsWithChildren<IBoxProps>>> = ({
  children,
  ...rest
}) => {
  return <BuilderBlock {...rest}>{children}</BuilderBlock>;
};

Box.craft = {
  displayName: "Box",
  props: {},

  related: {
    toolbar: BoxSettings,
    styles: StyleSettings,
  },
};

Box.defaultProps = {
  ...defaultStyleProps,
  overflow: "hidden",
  minWidth: "auto",
  minHeight: "auto",
  width: "100%",
  height: "200px",
  flexDirection: "column",
};
